import {NgClass} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {Router, RouterLink} from "@angular/router";
import {Component, inject, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';

import {NgSelectComponent} from "@ng-select/ng-select";

export const defaultPageLimit: number = 30;

export interface PageOption {
  number: number;
  label: string;
}

export interface PageLimitOption {
  id: number;
  name: string;
}

@Component({
  selector: 'nz-pagination',
  imports: [
    NgClass,
    RouterLink,
    FormsModule,
    NgSelectComponent
  ],
  templateUrl: './pagination.component.html',
  styleUrl: './pagination.component.scss'
})
export class PaginationComponent implements OnInit, OnChanges {
  private router: Router = inject(Router);

  @Input() totalResults: number = 0;
  @Input() selectedPage: number = 1;
  @Input() selectedPageLimitOptionId: number = defaultPageLimit;

  protected firstPage: number = 1;
  protected lastPage: number = 1;
  protected currentRoute: string = '';
  protected pageOptions: PageOption[] = [];
  protected pageLimitOptions: PageLimitOption[] = [];

  public ngOnInit(): void {
    this.currentRoute = this.router.url.split('?')[0];
    this.initializePageOptions();
    this.initializePageLimitOptions();
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes['totalResults'] || changes['selectedPage'] || changes['selectedPageLimitOptionId']) {
      this.initializePageOptions();
    }
  }

  protected onPageLimitOptionChange() {
    this.router.navigate([this.currentRoute], {
      queryParamsHandling: 'merge',
      queryParams:
        {page: 1, pageLimit: this.selectedPageLimitOptionId},
    }).then();
  }

  private initializePageOptions(): void {
    if (this.totalResults <= 0) return;

    this.pageOptions = [];
    this.lastPage = Math.ceil(this.totalResults / this.selectedPageLimitOptionId);

    const current: number = this.selectedPage;
    const last: number = this.lastPage;

    this.pageOptions.push({number: 1, label: '1'});

    if (current <= 3) {
      for (let i = 2; i <= Math.min(5, last - 1); i++) {
        this.pageOptions.push({number: i, label: i.toString()});
      }

      if (last > 5) {
        this.pageOptions.push({number: -1, label: '...'});
      }

      if (last > 1) {
        this.pageOptions.push({number: last, label: last.toString()});
      }

      return;
    }

    if (current > 3) {
      this.pageOptions.push({number: -1, label: '...'});
    }

    const middleStart = Math.max(2, current - 1);
    const middleEnd = Math.min(last - 1, current + 1);

    for (let i = middleStart; i <= middleEnd; i++) {
      this.pageOptions.push({number: i, label: i.toString()});
    }

    if (middleEnd < last - 1) {
      this.pageOptions.push({number: -2, label: '...'});
    }

    if (last > 1) {
      this.pageOptions.push({number: last, label: last.toString()});
    }
  }

  private initializePageLimitOptions(): void {
    this.pageLimitOptions = [
      {
        id: 30,
        name: '30 резултата'
      },
      {
        id: 45,
        name: '45 резултата'
      },
      {
        id: 60,
        name: '60 резултата'
      }
    ]
  }
}
